import common from "./common.json"
import landingPage from "./landing_page.json"

const ApplicationSettingsConfig = {
    common,
    landingPage
}

export default ApplicationSettingsConfig